export default __webpack_public_path__ + "static/media/IMG_9392.4be94870.JPG";